<template>
  <div id="app">
    <TopNav />
    <router-view class="router_view"/>
    <AppFooter class="mt30 footer" v-show="footerShow" />
  </div>
</template>

<script>
import TopNav from '@/components/Topnav/index'
import AppFooter from '@/components/Footer/footer'
import { HomeService } from './service/home.service'
export default {
  data() {
    return {
      shopIndex:[]
    }
  },
  computed: {
    footerShow() {
      return this.$store.getters.footerShow
    }
  },
  methods: {
    async getList() {
      const data = await HomeService.shopIndex()
      this.shopIndex = JSON.parse(JSON.stringify(data))
      this.$store.commit('calculationNumber',this.shopIndex.cart_num)
      this.$store.commit('set_shopIndex',this.shopIndex)
    },
  },
  created() {
    this.getList()
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
    }

    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  },
  name: 'app',
  components: {
    TopNav,
    AppFooter
  }
}
</script>

<style lang="scss" scoped>
 #app {
   height: 100%;
   overflow-y: auto;
   overflow-x: hidden;
 }
 .router_view{
   min-height: calc(100% - 326px)
 }
</style>
